import React from "react";
import ThemeProvider from 'react-bootstrap/ThemeProvider';

export default class Theme extends React.Component {

  render() {

    let prefix = 'aw-bs';

    let prefixes = {
      modal: `${prefix} modal`,
    }

    return(
      <ThemeProvider prefixes={prefixes}>
        <div className={`aw-bs`}>
          {this.props.children}
        </div>
      </ThemeProvider>
    )
  }

}